/*!
 * OrderRequestModal v1.1
 * Zelfstandig JS bestand voor Shopify — geen dependencies vereist.
 *
 * Gebruik in je Liquid template:
 *   OrderRequestModal.open('Houten Tafel', 'TAFEL-001');
 *
 * Optioneel: configureer voor laden
 *   OrderRequestModal.configure({ whatsappNumber: '31612345678' });
 */

(function (window, document) {
  "use strict";

  // ─── CONFIGURATIE ─────────────────────────────────────────────────────────
  // Pas deze waarden aan voor jouw winkel.

  var config = {
    whatsappNumber: "31612345678", // Landcode + nummer, zonder + of spaties
    labels: {
      title: "Informatie aanvragen",
      btnEmail: "Informatie via Email",
      btnWhatsapp: "Informatie via WhatsApp",
      sending: "Versturen\u2026",
      success: "Informatie aanvraag verstuurd! We nemen zo snel mogelijk contact op.",
      successWhatsapp: "Wanneer de informatie aanvraag via WhatsApp verstuurd is nemen we zo snel mogelijk contact op.",
      error:
        "Versturen mislukt. Probeer het opnieuw of neem direct contact op.",
      fieldName: "Naam",
      fieldEmail: "E-mailadres",
      fieldLicensePlate: "Kenteken",
      fieldPhone: "Telefoonnummer",
      fieldMessage: "Opmerking",
      placeholderName: "Jouw volledige naam",
      placeholderEmail: "jouw@email.nl",
      placeholderLicensePlate: "XX-123-X",
      placeholderPhone: "+31 6 12345678",
      placeholderMessage: "Eventuele opmerkingen\u2026",
    },
  };

  // ─── STATE ────────────────────────────────────────────────────────────────

  var initialized = false;
  var el = {}; // gecachte DOM-elementen
  var currentProduct = {}; // { name, articleNumber }

  // ─── INIT (lazy) ─────────────────────────────────────────────────────────
  // Wordt pas uitgevoerd bij eerste aanroep van open().

  function init() {
    if (initialized) return;

    injectHTML();
    cacheElements();
    bindEvents();

    initialized = true;
  }

  function injectHTML() {
    var L = config.labels;
    var html =
      '\
      <div id="orm-overlay" hidden>\
        <div class="orm-modal" role="dialog" aria-modal="true" aria-labelledby="orm-title">\
          <button class="orm-close" id="orm-close" type="button" aria-label="Sluiten">&times;</button>\
          <h2 class="orm-title" id="orm-title">' +
      L.title +
      '</h2>\
          <div class="orm-product-info" id="orm-product-info"></div>\
          <div id="orm-form">\
            <input type="hidden" id="orm-body" name="contact[body]">\
            <div class="orm-row">\
              <div class="orm-field">\
                <label for="orm-name">' +
      L.fieldName +
      ' <span aria-hidden="true">*</span></label>\
                <input type="text" id="orm-name" name="contact[name]" required\
                  autocomplete="name" placeholder="' +
      L.placeholderName +
      '">\
              </div>\
            </div>\
            <div class="orm-field">\
              <label for="orm-email">' +
      L.fieldEmail +
      ' <span aria-hidden="true">*</span></label>\
              <input type="email" id="orm-email" name="contact[email]" required\
                autocomplete="email" placeholder="' +
      L.placeholderEmail +
      '">\
            </div>\
            <div class="orm-row">\
              <div class="orm-field">\
                <label for="orm-phone">' +
      L.fieldPhone +
      '</label>\
                <input type="tel" id="orm-phone" name="contact[phone]" autocomplete="tel"\
                  placeholder="' +
      L.placeholderPhone +
      '">\
              </div>\
            </div>\
            <div class="orm-row">\
              <div class="orm-field">\
                <label for="orm-license-plate">' +
      L.fieldLicensePlate +
      ' <span aria-hidden="true">*</span></label>\
                <input type="text" id="orm-license-plate" required\
                  autocomplete="off" placeholder="' +
      L.placeholderLicensePlate +
      '" style="text-transform:uppercase">\
              </div>\
            </div>\
            <div class="orm-field">\
              <label for="orm-message">' +
      L.fieldMessage +
      '</label>\
              <textarea id="orm-message" rows="3"\
                placeholder="' +
      L.placeholderMessage +
      '"></textarea>\
            </div>\
            <div class="orm-actions">\
              <button type="submit" class="orm-btn orm-btn-email" id="orm-btn-email">\
                &#128231; ' +
      L.btnEmail +
      '\
              </button>\
              <button type="button" class="orm-btn orm-btn-whatsapp" id="orm-btn-whatsapp">\
                &#128172; ' +
      L.btnWhatsapp +
      '\
              </button>\
            </div>\
            <p class="orm-status" id="orm-status" role="status" aria-live="polite"></p>\
          </div>\
        </div>\
      </div>\
    ';

    var wrapper = document.createElement("div");
    wrapper.innerHTML = html.trim();
    document.body.appendChild(wrapper.firstElementChild);

    // De velden in het echte Shopify contactformulier (sections/product.liquid) plaatsen,
    // zodat Shopify's spambescherming (captcha) de inzending afhandelt zoals bij elk thema-formulier.
    var fields = document.getElementById("orm-form");
    var shopifyForm = document.getElementById("orm-csrf-source");
    shopifyForm.noValidate = true;
    while (fields.firstChild) shopifyForm.appendChild(fields.firstChild);
    fields.parentNode.replaceChild(shopifyForm, fields);
  }

  function cacheElements() {
    el.overlay = document.getElementById("orm-overlay");
    el.productInfo = document.getElementById("orm-product-info");
    el.form = document.getElementById("orm-csrf-source");
    el.body = document.getElementById("orm-body");
    el.name = document.getElementById("orm-name");
    el.email = document.getElementById("orm-email");
    el.licensePlate = document.getElementById("orm-license-plate");
    el.phone = document.getElementById("orm-phone");
    el.message = document.getElementById("orm-message");
    el.btnEmail = document.getElementById("orm-btn-email");
    el.btnWhatsapp = document.getElementById("orm-btn-whatsapp");
    el.status = document.getElementById("orm-status");
    el.close = document.getElementById("orm-close");
  }

  // ─── EVENTS ───────────────────────────────────────────────────────────────

  function bindEvents() {
    el.close.addEventListener("click", closeModal);

    el.overlay.addEventListener("click", function (e) {
      if (e.target === el.overlay) closeModal();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    });

    el.btnEmail.addEventListener("click", handleEmailClick);
    el.btnWhatsapp.addEventListener("click", handleWhatsappClick);
  }

  // ─── FORM HELPERS ─────────────────────────────────────────────────────────

  function getFormData() {
    return {
      name: el.name.value.trim(),
      email: el.email.value.trim(),
      licensePlate: el.licensePlate.value.trim().toUpperCase(),
      phone: el.phone.value.trim(),
      message: el.message.value.trim(),
    };
  }

  function validate(data) {
    if (!data.name) return "Vul je naam in.";
    if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      return "Vul een geldig e-mailadres in.";
    }
    if (!data.licensePlate) return "Vul je kenteken in.";
    return null;
  }

  function setStatus(text, type) {
    el.status.textContent = text;
    el.status.className = "orm-status" + (type ? " orm-status-" + type : "");
  }

  function buildMessageBody(data) {
    var lines = [
      "Artikel:      " + currentProduct.name,
      "Artikelnummer: " + currentProduct.articleNumber,
      "",
      "Naam:         " + data.name,
      "Kenteken:     " + data.licensePlate,
      "E-mail:       " + data.email,
      "Telefoon:     " + (data.phone || "Niet opgegeven"),
    ];
    if (data.message) {
      lines.push("", "Opmerking:", data.message);
    }
    return lines.join("\n");
  }

  // ─── EMAIL VIA SHOPIFY CONTACT FORM ───────────────────────────────────────

  function handleEmailClick(e) {
    var data = getFormData();
    var error = validate(data);

    if (error) {
      e.preventDefault();
      setStatus(error, "error");
      return;
    }

    // Geen preventDefault: de klik verstuurt het Shopify contactformulier zelf.
    // Shopify stuurt daarna terug naar deze pagina met ?contact_posted=true.
    el.body.value = buildMessageBody(data);
    el.btnEmail.textContent = config.labels.sending;
    setStatus("");
  }

  // ─── WHATSAPP ─────────────────────────────────────────────────────────────

  function handleWhatsappClick() {
    var data = getFormData();
    var error = validate(data);

    if (error) {
      setStatus(error, "error");
      return;
    }

    var lines = [
      "*Informatie aanvraag*",
      "",
      "*Artikel:* " + currentProduct.name,
      "*Artikelnummer:* " + currentProduct.articleNumber,
      "",
      "*Naam:* " + data.name,
      "*Kenteken:* " + data.licensePlate,
      "*E-mail:* " + data.email,
      "*Telefoon:* " + (data.phone || "Niet opgegeven"),
    ];
    if (data.message) {
      lines.push("", "*Opmerking:* " + data.message);
    }

    var url =
      "https://wa.me/" +
      config.whatsappNumber +
      "?text=" +
      encodeURIComponent(lines.join("\n"));
    window.open(url, "_blank", "noopener");
    setStatus(config.labels.successWhatsapp, 'success');
  }

  // ─── MODAL OPEN / CLOSE ───────────────────────────────────────────────────

  function openModal(productName, articleNumber) {
    init();

    currentProduct = {
      name: productName || "Onbekend",
      articleNumber: articleNumber || "-",
    };

    el.productInfo.innerHTML =
      "<strong>" +
      escapeHTML(currentProduct.name) +
      "</strong>" +
      "Artikelnummer: " +
      escapeHTML(currentProduct.articleNumber);

    el.form.reset();
    setStatus("");

    el.overlay.removeAttribute("hidden");
    el.name.focus();
  }

  function closeModal() {
    if (!initialized) return;
    el.overlay.setAttribute("hidden", "");
    setStatus("");
  }

  // ─── UTILS ────────────────────────────────────────────────────────────────

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // ─── RESULTAAT NA VERSTUREN ───────────────────────────────────────────────
  // sections/product.liquid rendert #orm-result-overlay nadat Shopify terugstuurt
  // met ?contact_posted=true (of met fouten). Hier alleen het sluiten.

  var resultOverlay = document.getElementById("orm-result-overlay");
  if (resultOverlay) {
    // ?contact_posted=true en #orm-csrf-source uit de URL halen, zodat F5 de melding niet opnieuw toont.
    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete("contact_posted");
    cleanUrl.hash = "";
    history.replaceState(history.state, "", cleanUrl);

    var closeResult = function () {
      resultOverlay.setAttribute("hidden", "");
    };
    resultOverlay.addEventListener("click", function (e) {
      if (e.target === resultOverlay || e.target.closest("[data-orm-result-close]")) {
        closeResult();
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeResult();
    });
  }

  // ─── PUBLIC API ───────────────────────────────────────────────────────────

  window.OrderRequestModal = {
    /**
     * Open de modal met een vooringevuld artikel.
     * @param {string} productName    - Naam van het artikel
     * @param {string} articleNumber  - Artikelnummer / SKU
     */
    open: openModal,

    /** Sluit de modal. */
    close: closeModal,

    /**
     * Overschrijf configuratie-opties (roep aan vóór open()).
     * @param {object} options - Gedeeltelijk config-object
     * @example
     *   OrderRequestModal.configure({ whatsappNumber: '31698765432' });
     */
    configure: function (options) {
      if (!options) return;
      if (options.whatsappNumber) {
        config.whatsappNumber = options.whatsappNumber;
      }
      if (options.labels) {
        for (var key in options.labels) {
          if (Object.prototype.hasOwnProperty.call(options.labels, key)) {
            config.labels[key] = options.labels[key];
          }
        }
      }
    },
  };
})(window, document);
